import React from "react";
import "./education.scss";
import EducationSystem from "./sections/educationSystem";
import EndToEndControl from "./sections/endToEndControl";
import FinancialList from "./sections/financialList";
import Letsgo from "../connectors/letsgo";

function Education() {
  return (
    <div className="container-education">
      <div className="section-education-system">
        <EducationSystem />
      </div>
      <div className="section-end-to-end-control">
        <EndToEndControl />
      </div>
      <div className="section-financial-list">
        <FinancialList />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  );
}

export default Education;
